//
import React, { Component } from 'react';
import './logoutComponent.css';
import AutenthicationService from '../services/authservice.js';

export default class LogoutComponent extends Component {
  constructor(props) {
    super(props);
    console.log(props);
    AutenthicationService.clearUserInfo();
  }
  state = {
    value: '',
  };

  componentDidMount(props) {
    setTimeout(() => {
      this.setState({ value: 'claudio' });
    }, 1000);

    setTimeout(() => {
      this.setState({ value: 'claudiomanno' });
    }, 2000);
    setTimeout(() => {
      this.props.history.push(`/`); //alt0096 | alt gr +'
    }, 3000);
  }
  aggiornaStato = (text) => {
    this.setState((prevValue) => prevValue + text);
    this.setState({ value: text });
  };

  componentDidUpdate(pp, ps) {
    console.log('aggiorna ', pp, 'ps: ', ps.value);
  }
  render(props) {
    // const nome = props.nome;
    // console.log('OUTPUT: LogoutComponent -> render -> nome', nome);

    return (
      <div>
        <div className='LogoutComponent mt-5'>
          <div className='container'>
            <div className='jumbotrons mt-2'>
              <h1 className='display-4'>
                <b>La procedura di logout è stata eseguita</b>
              </h1>
              <p className='lead'></p>
              <div>{this.state.value}</div>
            </div>
          </div>
        </div>
      </div>
    );
  }

  setMes = (event) => {
    setTimeout(() => {
      this.setState({ value: 'claudio' });
    }, 3000);
  };
}

//const LogoutComponent = (props) => {
//   let saluto = 'dddddddddddddd';
//   useEffect(() => {
//     console.log('OUTPUT: LogoutComponent -> props', props);

//     const timer = setTimeout(() => {
//       setCounta('ciao');
//     }, 1000);
//     return () => clearTimeout(timer);
//   }, []);
//   function setCounta(string) {
//     console.log('OUTPUT: setCount -> string', string);
//     saluto = string;
//     //this.setState({ isToken: true, path: '/login' });
//     // debugger;
//     props.history.push(`/`); //alt0096 | alt gr +'
//   }
//   return (
//     <div className='LogoutComponent mt-5'>
//       <div className='container'>
//         <div className='jumbotrons mt-2'>
//           <h1 className='display-4'>
//             <b>La procedura di logout è stata eseguita</b>
//           </h1>
//           <p className='lead'></p>
//           <p>{saluto}</p>
//         </div>
//       </div>
//     </div>
//   );
// };
//
